import axios from 'axios';

export const baseURL = 'http://localhost:8000';

export const API = axios.create({
  baseURL: baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});
